import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApprovedTrainingProviderCoursesModel } from 'src/app/models/approved-training-provider-courses.model';
import { ApprovedTrainingProviderSearchResultModel } from 'src/app/models/approved-training-provider-search-result.model';
import { BusinessInformationModel } from 'src/app/models/business-information.model';
import { CourseApproval } from 'src/app/models/course-approval.model';
import { ApprovedTrainingProviderCoursesMapper } from 'src/app/models/mappers/approved-training-provider-courses.mapper';
import { SigningAuthorityInformation } from 'src/app/models/signing-authority.model';
import { TPApplicationInfoModel } from 'src/app/models/training-provider-application.model';
import { TrainingProviderOnboardingModel } from 'src/app/models/training-provider-onboarding.model';
import { TrainingProviderSearchForm } from 'src/app/models/training-provider-search-form.model';
import { TrainingProvider } from 'src/app/models/training-provider.model';
import { environment } from 'src/environments/environment';
import { TrainingProviderServiceInterface } from './training-provider.interface';
import { InquiryRequestDTO } from 'src/app/models/inquiry-request.model';
import { TrainingProviderAccountSettings } from 'src/app/models/account-settings.model';

@Injectable({
  providedIn: 'root'
})
export class TrainingProviderService implements TrainingProviderServiceInterface {

  constructor(private httpClient: HttpClient) {
  }

  GetAllTrainingProvidersBySearchFragment(searchFragment: string): Observable<TrainingProvider[]> {
    return this.httpClient.post<any>(environment.apiBaseUrl + `TrainingProvider/getByNameOrId`, { SearchFragment: searchFragment }, { reportProgress: true });
  }

  GetTrainingProviderInfoByIdAndTrainingProgramId(trainingProviderId: string, trainingProgramId: string, captchaToken: string): Observable<ApprovedTrainingProviderCoursesModel> {
    return this.httpClient.get<any>(environment.apiBaseUrl + `TrainingProvider/getTrainingProviderInfoByIdAndTrainingProgramId/${trainingProviderId}/${trainingProgramId}/${captchaToken}`).pipe(map(this.trainingProviderApprovedCourseMapper));
  }

  GetTrainingProviderBySearchParams(trainingProviderSearchForm: TrainingProviderSearchForm): Observable<ApprovedTrainingProviderSearchResultModel[]> {
    return this.httpClient.post<any>(environment.apiBaseUrl + 'TrainingProvider/getTrainingProviderInfo/', trainingProviderSearchForm);
  }

  GetTrainingProviderCourseApprovals(trainingProviderId: string): Observable<CourseApproval[]> {
    return this.httpClient.get<any>(environment.apiBaseUrl + `TrainingProvider/GetCourseApprovalsByTrainingProviderId/${trainingProviderId}`);
  }

  RegisterTrainingProvider(onboardingSummary: TrainingProviderOnboardingModel): Observable<any> {
    return this.httpClient.post<any>(environment.apiBaseUrl + 'TrainingProvider/RegisterTrainingProvider/', onboardingSummary);
  }

  GetApplicantBusinessInformation(): Observable<BusinessInformationModel> {
    return this.httpClient.get<BusinessInformationModel>(environment.apiBaseUrl + 'TrainingProvider/GetApplicantBusinessInformation');
  }

  GetSigningAuthorityInformation(): Observable<SigningAuthorityInformation> {
    return this.httpClient.get<SigningAuthorityInformation>(environment.apiBaseUrl + 'TrainingProvider/GetSigningAuthority');
  }

  GetApplicationApplicantInformation(): Observable<TPApplicationInfoModel> {
    return this.httpClient.get<TPApplicationInfoModel>(environment.apiBaseUrl + 'TrainingProvider/GetApplicationApplicantInformation');
  }

  GetTeamMembersInfo(): Observable<any> {
    return this.httpClient.get<any>(environment.apiBaseUrl + `TeamMember/GetTrainingProviderTeamMembers`);
  }

  private trainingProviderApprovedCourseMapper = (tpac: any) => {
    return ApprovedTrainingProviderCoursesMapper.map(tpac);
  };
  SubmitInquiryRequest(request: InquiryRequestDTO): Observable<boolean> {
    return this.httpClient.post<boolean>(environment.apiBaseUrl + `TrainingProvider/SubmitInquiryRequest`, request);
  }

  GetAccountSettings(): Observable<TrainingProviderAccountSettings> {
    return this.httpClient.get<TrainingProviderAccountSettings>(environment.apiBaseUrl + `TrainingProvider/GetAccountSettings`);
  }

  SaveAccountSettings(accountSettings: TrainingProviderAccountSettings): Observable<boolean> {
    return this.httpClient.post<boolean>(environment.apiBaseUrl + `TrainingProvider/SaveAccountSettings`, accountSettings);
  }
}
